// src/app/shared/form-data-answers-create.ts
import { LegalPersonalityEnum, LegalPersonalityIdEnum } from 'src/app/domain/enums/legal-personality.enum';
import {
  ContributorTypeEnum,
  ContributorTypeIdEnum,
} from 'src/app/domain/registration/enums/contributor-type.enum';
import { FiscalEnvironmentIdEnum } from 'src/app/domain/registration/enums/fiscal-environment.enum';
import { GlobalUtils } from 'src/app/shared/global-utils';

export class FormDataAnswersCreateCustomer {
  public async build(answers: any): Promise<FormData> {
    let formData = new FormData();

    // 1. Mapeamento da Personalidade Jurídica
    // Obtém a chave exata do answers (ex: "Pessoa Física")
    const legalPersonalityKey = answers.legalPersonality;
    // Usa a chave diretamente para obter o ID do enum
    const legalPersonalityId = legalPersonalityKey ?
      LegalPersonalityIdEnum[legalPersonalityKey as keyof typeof LegalPersonalityIdEnum] : null;

    // Adiciona uma string vazia se for null para evitar problemas com formData.append
    formData.append('legalPersonality', legalPersonalityId !== null ? String(legalPersonalityId) : '');

    // 2. Mapeamento de CPF/CNPJ e Nomes
    // A comparação agora usa a chave string do enum para ser compatível
    if (legalPersonalityKey === LegalPersonalityEnum.PESSOA_FISICA) { 
      formData.append('cpf', answers.cpf || '');
      formData.append('name', answers.name?.toUpperCase() || '');
      formData.append('generalRegistration', answers.generalRegistration || '');
      // Campos de PJ não aplicáveis para PF
      formData.append('cnpj', '');
      formData.append('companyName', '');
      formData.append('stateRegistration', '');
      formData.append('municipalRegistration', '');
    } else { // Assumindo que o ELSE é para Pessoa Jurídica
      formData.append('cnpj', answers.cnpj || '');
      formData.append('companyName', answers.companyName?.toUpperCase() || '');
      formData.append('stateRegistration', answers.stateRegistration || '');
      formData.append('municipalRegistration', answers.municipalRegistration || '');
      // Campos de PF não aplicáveis para PJ
      formData.append('cpf', '');
      formData.append('name', '');
      formData.append('generalRegistration', '');
    }

    // 3. Mapeamento da Data de Aniversário
    const formattedBirthday = answers.birthday ? new Date(answers.birthday).toISOString().split('T')[0] : '';
    formData.append('birthday', formattedBirthday);

    // 4. Mapeamento de Outros Campos Comuns
    formData.append('isActive', 'true');
    formData.append('tradingName', answers.tradingName?.toUpperCase() || '');

    // --- Mapeamento CORRIGIDO do Tipo de Contribuinte ---
    const contributorTypeKey = answers.contributorType; // Isso deve ser 'CONTRIBUINTE' ou 'NÃO CONTRIBUINTE'

    // Garante que a chave existe no enum e obtém o ID numérico correspondente
    let contributorTypeIdToAppend: string | number = '';
    if (contributorTypeKey && ContributorTypeIdEnum.hasOwnProperty(contributorTypeKey)) {
      contributorTypeIdToAppend = ContributorTypeIdEnum[contributorTypeKey as keyof typeof ContributorTypeIdEnum];
    }
    // Garante que o valor é uma string antes de anexar ao FormData
    formData.append('contributorType', String(contributorTypeIdToAppend));

    formData.append('phone', answers.phone || '');
    formData.append('cellPhone', answers.cellPhone || '');
    formData.append('email', answers.email || '');
    formData.append('webSite', answers.webSite || '');
    formData.append('cep', answers.cep || '');
    formData.append('address', answers.address || '');
    formData.append('addressComplement', answers.addressComplement || '');
    formData.append('addressNumber', answers.addressNumber || '');
    formData.append('neighborhood', answers.neighborhood || '');
    formData.append('state', answers.state || '');
    formData.append('city', answers.city || '');

    formData.append('addressObservation', '');
    formData.append('externalCode', '');
    formData.append('country', '');
    formData.append('mainActivity', answers.mainActivity || '');
    formData.append('contract', '');
    formData.append('signedAt', '');
    formData.append('license', '');
    formData.append('lastBackup', '');

    const customerPlans = answers.fullPlan ? [{
      terminalQuantity:answers.fullPlan.terminalQuantity,
      monthlyValue: answers.fullPlan.monthlyValue,
      dueDate:answers.fullPlan.dueDate,
      adhesionFee:answers.fullPlan.adhesionFee,
      active: answers.fullPlan.isActive,
      system: answers.fullPlan.systemId,
      type: answers.fullPlan.type,
      daysCountQuantity: answers.dueInDays,
      systemModules:answers.systemModule,
      deploymentValue: answers.deploymentValue || 0,
      daysCountValue: answers.daysCountValue || 0
     }] : [];
    formData.append('customerPlans', JSON.stringify(customerPlans));
    formData.append('accessQuantity', '0');

    formData.append('consultant', '');
    formData.append('consultantCommission', '0');
    formData.append('partner', answers.partnerId || '');
    formData.append('partnerCommission', answers.partnerCommission || '');
    formData.append('representative', '');
    formData.append('representativeCommission', '0');
    formData.append('counter', '');
    formData.append('counterCommission', '0');
    formData.append('unit', '');
    formData.append('unitCommission', '0');

    formData.append('regime', '1');
    formData.append('fiscalEnvironment', FiscalEnvironmentIdEnum[answers.fiscalEnvironment]);
    formData.append('csc', answers.csc || '');
    formData.append('cscId', answers.cscId || '');
 
    formData.append('digitalCertificate', answers.digitalDocument || null);
    formData.append('documentPhoto', answers.documentPhoto || null);
    formData.append('image', answers.image || null);

    formData.append('contractComment', '');
    formData.append('contractDate', '');
    formData.append('licenseComment', '');
    formData.append('licenseDate', '');
    formData.append('lastBackupComment', '');
    formData.append('lastBackupDate', '');
    formData.append('digitalCertificateComment', '');
    formData.append('digitalCertificateDate', '');


    return formData;
  }
}